import React, { useRef } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { buildName, Singleton } from "helper/tools";
import ProgressRing from "../ProgressRing/ProgressRing";
import BadgeStatus from "./BadgeStatus";
import { handleNivel } from "../../helperFunctions/helpers";

export default function AsociadosKPITable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <table
      className="table table-borderless datable sortable table-hover"
      style={{ tableLayout: "fixed" }}
    >
      <thead className="table-light" style={{ textAlign: "center" }}>
        <tr ref={theadRef}>
          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.id"
            style={{ width: "90px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Id
          </th>
          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.nombre"
            style={{ verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Nombre
          </th>
          {/*  TODO: hasta que se agreguen otras sucursales *1 <th
        scope="col"
        data-column="responsable"
        onClick={(event) => handleSort(event)}
      >
        Responsable
      </th>*/}
          <th
            colSpan={4}
            scope="col"
            className="no-sort"
            style={{ borderBottom: "solid" }}
          >
            Credito
          </th>

          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.nivelId"
            style={{ width: "100px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Nivel
          </th>

          <th
            rowSpan={2}
            scope="col"
            data-column="sum"
            onClick={(event) => handleSort(event)}
            style={{ width: "190px", verticalAlign: "middle" }}
          >
            Calidad de Información
          </th>
          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.activo"
            style={{ width: "100px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Estatus
          </th>
        </tr>
        <tr>
          <th
            scope="col"
            data-column="asociado.limiteCredito"
            style={{ width: "140px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Limite
          </th>
          <th
            scope="col"
            data-column="asociado.credito"
            onClick={(event) => handleSort(event)}
            style={{ width: "100px" }}
          >
            Dispuesto
          </th>
          <th
            scope="col"
            data-column="asociado.CredDisPor"
            onClick={(event) => handleSort(event)}
            style={{ width: "100px" }}
          >
            % Dispuesto
          </th>
          <th
            scope="col"
            data-column="asociado.CreditoDisponible"
            onClick={(event) => handleSort(event)}
          >
            Disponible
          </th>
        </tr>
      </thead>
      <tbody>
        {isLoading && <SkeletonTable columnCount={9} rowCount={6} />}

        {!isLoading &&
          items?.length > 0 &&
          items?.map((data, index) => {
            const { sum, asociado } = data;
            const item = asociado;
            const nombre = buildName(item, true);

            const creditoDispuesto = Singleton.getInstance().format(
              item.credito,
            );
            const limiteCredito = Singleton.getInstance().format(
              item.limiteCredito,
            );
            const creditoDispuestoPer = item.credDisPor;
            const creditoDisponible = Singleton.getInstance().format(
              item.creditoDisponible,
            );

            return (
              <tr key={item.id}>
                <th
                  scope="row"
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "center",
                  }}
                >
                  <a href="#" onClick={(e) => openItem(item)}>
                    {item.numAsociado ?? ""}
                  </a>
                </th>
                <td>
                  <a
                    href="#"
                    className="text-primary"
                    onClick={(e) => openItem(item)}
                  >
                    {nombre}
                  </a>
                </td>
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  {limiteCredito}
                </td>
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  {creditoDispuesto}
                </td>
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  {creditoDispuestoPer}
                </td>
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  {creditoDisponible}
                </td>
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  <span className={`badge ${handleNivel(item.nivel?.id)}`}>
                    {item.nivel?.nombre}
                  </span>
                </td>

                <td style={{ justifyContent: "center", display: "flex" }}>
                  <ProgressRing
                    radiusProp={25}
                    strokeProp={6}
                    strokeColor={"red"}
                    progress={sum}
                  />
                </td>
                <BadgeStatus item={item} />
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
